import type { ScreenContext } from './types.ts';
import { createContinueButton, setButtonLoading } from '@/components/continue-button.ts';

export function renderReflection(container: HTMLElement, ctx: ScreenContext) {
  const { dispatch } = ctx;
  const startedAt = performance.now();

  container.innerHTML = `
    <div class="card space-y-6">
      <div>
        <p class="text-sm uppercase tracking-wide text-gray-500">Reflect</p>
        <h2 class="text-2xl font-semibold text-gray-900">Quick reflection</h2>
        <p class="text-gray-700 mt-1">Answer a few questions to wrap up.</p>
      </div>
      <div class="space-y-4">
        <div class="space-y-2">
          <p class="font-medium text-gray-900">Did the music affect you even after each track ended?</p>
          <div class="flex flex-col gap-2 text-sm text-gray-700">
            <label class="flex items-center gap-2"><input type="radio" name="q1" value="no">No</label>
            <label class="flex items-center gap-2"><input type="radio" name="q1" value="a_little">A little</label>
            <label class="flex items-center gap-2"><input type="radio" name="q1" value="clearly">Clearly</label>
          </div>
        </div>
        <div class="space-y-2">
          <label class="font-medium text-gray-900" for="q2">How much did your emotional state shift overall? (0-10)</label>
          <input id="q2" type="range" min="0" max="10" value="5" class="w-full">
        </div>
        <div class="space-y-2">
          <label class="font-medium text-gray-900" for="q3">Do you feel more confident using music intentionally? (0-10)</label>
          <input id="q3" type="range" min="0" max="10" value="5" class="w-full">
        </div>
        <div class="space-y-2">
          <label class="font-medium text-gray-900" for="reflection-note">Tell us more</label>
          <p class="text-sm text-gray-600">How did this session affect you? How might you use music in the future? Did you gain anything meaningful?</p>
          <textarea id="reflection-note" rows="4" class="w-full border border-gray-200 rounded-lg p-3 text-sm" placeholder="Share your thoughts..."></textarea>
        </div>
      </div>
      <div id="action-slot"></div>
    </div>
  `;

  const btn = createContinueButton('See results');
  container.querySelector('#action-slot')?.appendChild(btn);

  btn.addEventListener('click', () => {
    const q1 = (container.querySelector('input[name="q1"]:checked') as HTMLInputElement)?.value;
    const q2 = Number((container.querySelector('#q2') as HTMLInputElement)?.value || '0');
    const q3 = Number((container.querySelector('#q3') as HTMLInputElement)?.value || '0');
    const note = (container.querySelector('#reflection-note') as HTMLTextAreaElement)?.value?.trim() ?? '';
    const durationMs = Math.round(performance.now() - startedAt);

    if (!q1) {
      alert('Please choose an option for question 1.');
      return;
    }

    setButtonLoading(btn, true, 'See results', 'Saving...');
    dispatch({ type: 'SET_REFLECTIONS', payload: { q1, q2, q3, note, durationMs } });
    dispatch({ type: 'NEXT_PHASE' });
    setButtonLoading(btn, false, 'See results');
  });
}
